var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInsights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C11.4948 22 11.0593 21.8165 10.6933 21.4496C10.3273 21.0827 10.1283 20.6344 10.0963 20.1048H13.9038C13.8718 20.6344 13.6728 21.0827 13.3068 21.4496C12.9408 21.8165 12.5052 22 12 22ZM8.25 18.653V17.0805H15.75V18.653H8.25ZM8.40375 15.629C7.35642 14.9461 6.52733 14.054 5.9165 12.9525C5.3055 11.8511 5 10.6465 5 9.33868C5 7.29573 5.6795 5.56188 7.0385 4.13713C8.3975 2.71238 10.0513 2 12 2C13.9487 2 15.6025 2.71238 16.9615 4.13713C18.3205 5.56188 19 7.29573 19 9.33868C19 10.6465 18.6945 11.8511 18.0835 12.9525C17.4727 14.054 16.6436 14.9461 15.5963 15.629H8.40375ZM8.85 14.0564H15.15C15.9 13.4973 16.4792 12.8071 16.8875 11.9858C17.2958 11.1646 17.5 10.2822 17.5 9.33868C17.5 7.73116 16.9667 6.36826 15.9 5.24999C14.8333 4.13171 13.5333 3.57257 12 3.57257C10.4667 3.57257 9.16667 4.13171 8.1 5.24999C7.03333 6.36826 6.5 7.73116 6.5 9.33868C6.5 10.2822 6.70417 11.1646 7.1125 11.9858C7.52083 12.8071 8.1 13.4973 8.85 14.0564Z",
    fill: "#05241B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInsights);
export default __webpack_public_path__ + "static/media/iconInsights.550175fc.svg";
export { ForwardRef as ReactComponent };